import { Buffer } from 'buffer';

const Base62Chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const Base62Length = Base62Chars.length;

// Encode a number into a Base62 string
function EncodeNumber(id: number | null): string {
    if (id !== null) {
        // Convert number to a string
        const original = id.toString();

        // Convert to bytes using TextEncoder (equivalent to UTF8.GetBytes in C#)
        const encoder = new TextEncoder();
        const inputBytes = encoder.encode(original);

        // Convert byte array to BigInt
        let number = BigInt(0);
        for (let i = 0; i < inputBytes.length; i++) {
            number = number * BigInt(256) + BigInt(inputBytes[i]);
        }

        // Encode the number to Base62
        let sb = '';
        while (number > 0) {
            const remainder = Number(number % BigInt(Base62Length));
            sb = Base62Chars[remainder] + sb;
            number /= BigInt(Base62Length);
        }

        return sb;
    }
    return '';
}

// Decode a Base62 string into a number
function DecodeNumber(encodedInput: string | null): number {
  if(encodedInput)
  {
    const isNumeric = /^[0-9]+$/.test(encodedInput);
    if (!isNumeric) {
      try {
          let number = BigInt(0);
          for (const c of encodedInput) {
              const value = Base62Chars.indexOf(c);
              if (value === -1) {
                  console.warn("Invalid character in encoded string:", c);
                  return 0;
              }
              number = number * BigInt(Base62Length) + BigInt(value);
          }
          
          const hexString = number.toString(16);
          const paddedHex = hexString.length % 2 === 0 ? hexString : '0' + hexString;
          const byteArray = hexStringToByteArray(paddedHex).reverse();
          const decodedString = new TextDecoder().decode(new Uint8Array(byteArray));
          const reversedString = decodedString.split('').reverse().join('');
          
          return ExtractNumbers(reversedString);
      } catch (error) {
          console.error("Decode error:", error);
          return 0;
      }
    } else {
        return parseInt(encodedInput, 10);
    }
  }
  return 0;
}
// function DecodeNumber(encodedInput: string | null): number {
//     if(encodedInput)
//     {
//         const isNumeric = /^[0-9]+$/.test(encodedInput);
//         if (!isNumeric) {
//             let number = BigInt(0);
//             // Decode from Base62
//             for (const c of encodedInput) {
//                 const value = Base62Chars.indexOf(c);
//                 if (value === -1) {
//                     throw new Error("Invalid character in encoded string.");
//                 }
//                 number = number * BigInt(Base62Length) + BigInt(value);
//             }

//             // Convert BigInt to byte array
//             const hexString = number.toString(16);
//             const byteArray = hexStringToByteArray(hexString).reverse();

//             // Convert bytes back to string
//             const decodedString = new TextDecoder().decode(new Uint8Array(byteArray));
//             const reversedString = decodedString.split('').reverse().join('');
//             return ExtractNumbers(reversedString);
//         } else {
//             return parseInt(encodedInput, 10);
//         }
//     }
//     return 0;
// }

function hexStringToByteArray(hex: string): number[] {
    const byteArray: number[] = [];
    for (let i = 0; i < hex.length; i += 2) {
        byteArray.push(parseInt(hex.slice(i, i + 2), 16));
    }
    return byteArray;
}

// Assuming ExtractNumbers processes the decoded string and returns a number
function ExtractNumbers(decodedString: string): number {
    // Extract digits from the string using a regular expression
    const numericString = decodedString.replace(/\D/g, '');  // Remove non-digit characters

    // Parse the numeric string to a number
    const result = parseInt(numericString, 10);

    // If parsing failed, return NaN (or handle as needed)
    if (isNaN(result)) {
        throw new Error("No valid numeric value found.");
    }

    return result;
}


export const Extract = {
    Key:{
        Encode: EncodeNumber,
        Decode: DecodeNumber,
    }
};
